import axios from 'axios'
// import store from '@/store'
import querystring from 'querystring'
import {
  Toast
} from 'vant'
import {
  verify,
  objReduce
} from './utils.js'
import router from '../router'
import constant from './constant'
import appconfig from '@/appconfig.js'

// const commit = store.commit || store.dispatch
const base = appconfig.httpServer + constant.apiBase;

let loadingToast

axios.defaults.baseURL = ''
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.withCredentials = true
axios.defaults.transformRequest = [
  function (data) {
    return querystring.stringify(data)
  }
]
//  添加一个请求拦截器
axios.interceptors.request.use(function (config) {
  loadingToast = Toast.loading({
    duration: 0, // 持续展示 toast
    forbidClick: true, // 禁用背景点击
    loadingType: 'spinner',
    message: '加载中'
  });
  // commit('UPDATE_LOADING', true)
  return config
}, function (error) {
  return Promise.reject(error)
})
//  添加一个响应拦截器
axios.interceptors.response.use(res => {
  if (res.status === 200) {
    if (res.data.code === 401) {
      console.log('登录超时')
      router.replace('/login')
    }
  }
  // commit('UPDATE_LOADING', false)
  loadingToast.clear()
  return res
}, err => {
  // commit('UPDATE_LOADING', false)
  loadingToast.clear()
  console.log('lanjieqi', err)
  // if (appconfig.mainServer) {}
  Toast.fail('网络有问题');
  return Promise.reject(err)
})

const http = {
  get: function (url, params, rules, type) {
    if (type === undefined) {
      if (rules === undefined) {
        rules = {}
      } else if (typeof rules === 'boolean') {
        type = rules;
        rules = {};
      }
    }
    if (params === undefined) {
      params = {}
    } else {
      params = objReduce(params, type)
    }
    if (!verify(rules, params)) {
      return Promise.reject(params)
    };
    return new Promise((resolve, reject) => {
      axios.get(base + url + '?' + querystring.stringify(params)).then(res => {
        if (res.data.code === 200) {
          resolve(res.data)
        } else if (res.data.code === 500) {
          Toast.fail(res.data.message);
          reject(res.data)
        }
      })
    })
  },
  post: function (url, params, rules, type) {
    if (type === undefined) {
      if (rules === undefined) {
        rules = {}
      } else if (typeof rules === 'boolean') {
        type = rules;
        rules = {};
      }
    }
    if (params === undefined) {
      params = {}
    }
    params = objReduce(params, type)
    if (!verify(rules, params)) {
      return Promise.reject(params)
    };
    return new Promise((resolve, reject) => {
      axios.post(base + url, params).then(res => {
        if (res.data.code === 200) {
          resolve(res.data)
        } else if (res.data.code === 500) {
          Toast.fail(res.data.message);
          reject(res.data)
        }
      })
    })
  }
}

export default http
export const Axios = axios
export const get = (url, params, rules, type) => http.get(url, params, rules, type).then(res => res)
export const post = (url, params, rules, type) => http.post(url, params, rules, type).then(res => res)



// WEBPACK FOOTER //
// ./src/common/http.js